import { GGetAgentConversationsFilterInput } from "src/generated/graphql";
import { Store } from "stores/store";

export interface SessionSettingStoreData {
  conversationListFilter: GGetAgentConversationsFilterInput | null;
  conversationListFilterIsCustom: boolean;
}

export class SessionSettingsGlobalStore extends Store<SessionSettingStoreData> {
  private conversationListFilter: GGetAgentConversationsFilterInput | null = null;
  private conversationListFilterIsCustom: boolean = false;

  protected data(): SessionSettingStoreData {
    return {
      conversationListFilter: null,
      conversationListFilterIsCustom: false,
    };
  }

  setConversationsFilter(filter: GGetAgentConversationsFilterInput, isCustom: boolean) {
    console.log("Applying filter", filter);
    this.state.conversationListFilter = filter;
    this.state.conversationListFilterIsCustom = isCustom;
  }

  hasCustomConversationFilter() {
    return this.state.conversationListFilterIsCustom;
  }

  getConversationFilter() {
    return this.state.conversationListFilter;
  }
}

export const sessionSettingsStore = new SessionSettingsGlobalStore();
